const GET_DATA_FROM_API = 'GET_DATA_FROM_API';
const ERR_OCCURED = 'ERR_OCCURED';
const ASYNC_FETCH = 'ASYNC_FETCH';
const PLAN_SELECTED = 'PLAN_SELECTED';
const UPDATE_SFO = 'UPDATE_SFO';
const UPDATE_SFO_DATA = 'UPDATE_SFO_DATA';
const RESET_PROMO_UPDATED = 'RESET_PROMO_UPDATED';
const INVALID_CASE_ERROR = 'INVALID_CASE_ERROR';
const CEF_PLANS_ERROR = 'CEF_PLANS_ERROR';
const FCC_LABEL = 'FCC_LABEL';
const FCC_LABEL_SUCCESS = 'FCC_LABEL_SUCCESS';
const FCC_LABEL_ERROR = 'FCC_LABEL_ERROR';
const BANNER_PROMOTION_FLOW = 'BANNER_PROMOTION_FLOW';
const BANNER_PROMOTION_FLOW_VALUE = 'BANNER_PROMOTION_FLOW_VALUE';

const DEFAULT_ERROR_MESSAGE = 'Looks like something went wrong. Please try again later.';
export const TOGGLE_ACP_MODAL = 'TOGGLE_ACP_MODAL';
export const RESET_ACP_MODAL = 'RESET_ACP_MODAL';
export const TOGGLE_VF_MODAL = 'TOGGLE_VF_MODAL';
export const RESET_VF_MODAL = 'RESET_VF_MODAL';
export const UPDATE_ACPMODAL_AL_STATUS = 'UPDATE_ACPMODAL_AL_STATUS';
export const UPDATE_VFMODAL_AL_STATUS = 'UPDATE_VFMODAL_AL_STATUS';

export const FED_DISCOUNT_MAPPING = {
  UNLIMITED: 'unlimited',
  LOYALTY: 'loyalty',
  AUTOPAY: 'autopay',
  EMPLOYEE: 'employee',
  MHPREMIUM: 'MHPremium',
};

export {
  GET_DATA_FROM_API,
  ERR_OCCURED,
  ASYNC_FETCH,
  PLAN_SELECTED,
  UPDATE_SFO,
  UPDATE_SFO_DATA,
  RESET_PROMO_UPDATED,
  INVALID_CASE_ERROR,
  CEF_PLANS_ERROR,
  DEFAULT_ERROR_MESSAGE,
  FCC_LABEL,
  FCC_LABEL_SUCCESS,
  FCC_LABEL_ERROR,
  BANNER_PROMOTION_FLOW,
  BANNER_PROMOTION_FLOW_VALUE,
};
